import { cn } from './cn';

/** Display card — hover/focus-within lift; use on static content panels. */
export const SURFACE_REVEAL = 'surface-reveal';

/** Clickable card — pointer + stronger hover; pair with links/buttons inside. */
export const SURFACE_INTERACTIVE = 'surface-interactive';

/** Form / dialog shell — suppresses hover lift on glass panels. */
export const SURFACE_STATIC = 'surface-static';

/** Standard elevated marketing/home card. */
export function surfaceCard(className?: string): string {
  return cn('page-glass-panel page-glass-panel--elevated', SURFACE_REVEAL, className);
}

/** Elevated card that acts as a single interactive target (or wraps links). */
export function surfaceCardInteractive(className?: string): string {
  return cn('page-glass-panel page-glass-panel--elevated', SURFACE_INTERACTIVE, className);
}

/** Capability / dynamic grid cell (`styles/widget/content-display-components/card.css`). */
export function simpleCard(className?: string): string {
  return cn('simple-card', SURFACE_REVEAL, className);
}
